import {
  Component,
  OnInit,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
// import { MdIconModule, MdButtonModule } from '@angular/material';

import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_BUTTON = [
  'oattr: attr',
  'olabel: label',

  // type [FLAT|RAISED|ICON|FAB|MINI-FAB]: The type of button. Default: FLAT.
  'otype: type',

  //icon [string]: Name of google icon (see https://design.google.com/icons/)
  'icon',
  'iconPosition : icon-position',
  'image'
];



export class OButtonComponent implements OnInit {

  public static DEFAULT_INPUTS_O_BUTTON = DEFAULT_INPUTS_O_BUTTON;

  protected static DEFAULT_TYPE = 'RAISED';

  protected oattr: string;
  protected olabel: string;
  protected otype: string;
  protected icon: string;
  protected iconPosition: string; // left (default), top, TODO: right, bottom?
  protected image: string;

  constructor() {
    this.otype = OButtonComponent.DEFAULT_TYPE;
  }

  ngOnInit(): void {
    if (this.otype) {
      this.otype = this.otype.toUpperCase();
    }
  }

  get needsIconButtonClass(): boolean {
    return this.icon !== undefined && (this.olabel === undefined || this.olabel === '');
  }

  isFloating() : boolean {
    return this.otype === 'FLOATING';
  }

  isRaised() : boolean {
    return ((this.otype === 'RAISED') || !this.otype);
  }

  isFlat() : boolean {
    return this.otype === 'FLAT';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-button',
  inputs: [
    ...DEFAULT_INPUTS_O_BUTTON
  ],
  template: `
    <button *ngIf="isFloating()" md-fab class="mat-fab">
      <img src="{{ image }}" class="o-button-image" *ngIf="image!=undefined"/>
      <i md-icon class="material-icons o-button-icon" *ngIf="icon!=undefined" style="vertical-align:middle">{{icon}}</i>
      <br *ngIf="iconposition==='top'" />
      <span *ngIf="olabel!=undefined" class="o-button-text">{{ olabel | oTranslate }}</span>
    </button>

    <button *ngIf="isRaised()" md-raised-button class="mat-raised-button" [class.mat-icon-button]="needsIconButtonClass">
      <img src="{{ image }}" class="o-button-image" *ngIf="image!=undefined"/>
      <i md-icon class="material-icons o-button-icon" *ngIf="icon!=undefined" style="vertical-align:middle">{{icon}}</i>
      <br *ngIf="iconposition==='top'" />
      <span *ngIf="olabel!==undefined" class="o-button-text">{{ olabel  | oTranslate }}</span>
    </button>

    <button *ngIf="isFlat()" md-button class="mat-button" [class.mat-icon-button]="needsIconButtonClass">
      <img src="{{ image }}" class="o-button-image" *ngIf="image!=undefined"/>
      <i md-icon class="material-icons o-button-icon" *ngIf="icon!=undefined" style="vertical-align:middle">{{icon}}</i>
      <br *ngIf="iconposition==='top'" />
      <span *ngIf="olabel!=undefined" class="o-button-text">{{ olabel | oTranslate }}</span>
    </button>
  `,
  styles: [`

  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class OButtonModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OButtonComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OButtonComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
